export default __webpack_public_path__ + "static/media/acne-scar.0f136c5f.pdf";